import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Failure = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/student/home", {
      replace: true,
      state: { paymentResult: "failure" },
    });
  }, [navigate]);

  return null;
};

export default Failure;
